import { Layout, Menu, Typography } from 'antd';
import {
  UserOutlined
} from '@ant-design/icons';
import { Component } from 'react';
import { Route, HashRouter as Router, Routes } from 'react-router-dom';
import JDProductsEdit from './components/jd_products_edit';
import JDProductsPrint from './components/jd_products_print';
import UsecubesBarcodeEdit from './components/usecubes_barcode_edit';
import UsecubesEANcodeEdit from './components/usecubes_eancode_edit';
import UsecubesQrcode from './components/usecubes_qrcode';
import Login from './components/login';
import UsecubesAllStar from './components/usecubes-all-star';
import BackroomsCard from './components/backrooms-card';
import BackroomsLevelCard from './components/backrooms-level-card';
import BackroomsTeamCard from './components/backrooms-team-card';
import SkibidiCard from './components/skibidi-card';
import RhythmBoxModule from './components/rhythm-box-module';
import UmaCard from './components/uma-card';
import AiShanhaijingAdmin from './components/ai-shanhaijing-admin';
import UrbanLegendAdmin from './components/urban-legend-admin';
import StarCardAdmin from './components/star-card-admin';
import EntityFileAdmin from './components/entity-file-admin';
import SyntheticAdmin from './components/synthetic-admin';
import DeepMonstersAdmin from './components/deep-monsters-admin';
import CardMakerAdmin from './components/card-maker-admin';
import { Gjp, GjpOrder } from './components/gjp';
import { ProtectedRoute } from './components/ProtectedRoute';
import './App.less';

const { Sider, Content } = Layout;
const { Link } = Typography;


class MainLayout extends Component {
  state = {
    collapsed: false,
  };

  onCollapse = (collapsed: any) => {
    this.setState({ collapsed });
  };

  getMenuItems = () => [
    {
      key: 'sub5',
      icon: <UserOutlined />,
      label: '像素屋条码',
      children: [
        {
          key: '7',
          label: <Link href="/#/tools/usecubes_code/edit">像素屋条码维护</Link>,
        },
        {
          key: '10',
          label: <Link href="/#/tools/usecubes_eancode/edit">EAN编码维护</Link>,
        },
      ],
    },
    {
      key: 'sub6',
      icon: <UserOutlined />,
      label: '像素屋二维码',
      children: [
        {
          key: '8',
          label: <Link href="/#/tools/usecubes_qrcode/generate">像素屋二维码</Link>,
        },
      ],
    },
    {
      key: 'sub7',
      icon: <UserOutlined />,
      label: '像素屋商品',
      children: [
        {
          key: '9',
          label: <Link href="/#/tools/usecubes_all_star">MC全明星卡</Link>,
        },
        {
          key: '11',
          label: <Link href="/#/tools/backrooms_card">后室卡牌</Link>,
        },
        {
          key: 'backrooms_level_card',
          label: <Link href="/#/tools/backrooms_level_card">后室层级卡牌</Link>,
        },
        {
          key: 'backrooms_team_card',
          label: <Link href="/#/tools/backrooms_team_card">后室团队卡牌</Link>,
        },
        {
          key: '12',
          label: <Link href="/#/tools/skibidi_card">马桶人卡牌</Link>,
        },
        {
          key: '13',
          label: <Link href="/#/tools/rhythm_box_module">节奏盒子模组卡</Link>,
        },
        {
          key: '14',
          label: <Link href="/#/tools/uma_card">UMA卡牌</Link>,
        },
        {
          key: '15',
          label: <Link href="/#/tools/ai_shanhaijing_admin?tab=evolution-cards">AI山海经管理</Link>,
        },
        {
          key: '16',
          label: <Link href="/#/tools/urban_legend_admin">都市传说管理</Link>,
        },
        {
          key: '17',
          label: <Link href="/#/tools/star_card_admin">星球卡管理</Link>,
        },
        {
          key: '18',
          label: <Link href="/#/tools/entity_file_admin">实体档案管理</Link>,
        },
        {
          key: '19',
          label: <Link href="/#/tools/deep_monsters_admin">深海巨兽管理</Link>,
        },
        {
          key: '20',
          label: <Link href="/#/tools/synthetic_admin">伪人游戏管理</Link>,
        },
        {
          key: '21',
          label: <Link href="/#/tools/card_maker_admin">卡牌制作管理</Link>,
        },
      ],
    },
    {
      key: 'sub1',
      icon: <UserOutlined />,
      label: '京东条码打印服务',
      children: [
        {
          key: '1',
          label: <Link href="/#/tools/jd_products/print">京东条码打印</Link>,
        },
        {
          key: '2',
          label: <Link href="/#/tools/jd_products/edit">京东条码维护</Link>,
        },
      ],
    },
    {
      key: 'sub3',
      icon: <UserOutlined />,
      label: '管家婆库位管理',
      children: [
        {
          key: '5',
          label: <Link href="/#/tools/gjp">可用库位查询</Link>,
        },
      ],
    },
    {
      key: 'sub4',
      icon: <UserOutlined />,
      label: '管家婆订单处理',
      children: [
        {
          key: '6',
          label: <Link href="/#/tools/gjp_order">订单导出后处理</Link>,
        },
      ],
    },
  ];

  render() {
    const { collapsed } = this.state;
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible collapsed={collapsed} onCollapse={this.onCollapse}>
          <div className="logo">
            像素屋工具
          </div>
          <Menu 
            theme="dark" 
            mode="inline"
            items={this.getMenuItems()}
          />
        </Sider>
        <Content>
          {this.props.children}
        </Content>
      </Layout>
    );
  }
}

class EmptyLayout extends Component {
  render() {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Content>
          {this.props.children}
        </Content>
      </Layout>
    );
  }
}

class App extends Component {
  render() {
    return (
      <Router>
        <Routes>
          <Route path="/tools/usecubes_code/edit" element={<ProtectedRoute><MainLayout><UsecubesBarcodeEdit/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/usecubes_eancode/edit" element={<ProtectedRoute><MainLayout><UsecubesEANcodeEdit/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/usecubes_qrcode/generate" element={<ProtectedRoute><MainLayout><UsecubesQrcode/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/jd_products/print" element={<ProtectedRoute><MainLayout><JDProductsPrint/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/jd_products/edit" element={<ProtectedRoute><MainLayout><JDProductsEdit/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/usecubes_all_star" element={<ProtectedRoute><MainLayout><UsecubesAllStar/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/backrooms_card" element={<ProtectedRoute><MainLayout><BackroomsCard/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/backrooms_level_card" element={<ProtectedRoute><MainLayout><BackroomsLevelCard/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/backrooms_team_card" element={<ProtectedRoute><MainLayout><BackroomsTeamCard/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/skibidi_card" element={<ProtectedRoute><MainLayout><SkibidiCard/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/rhythm_box_module" element={<ProtectedRoute><MainLayout><RhythmBoxModule/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/uma_card" element={<ProtectedRoute><MainLayout><UmaCard/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/ai_shanhaijing_admin" element={<ProtectedRoute><MainLayout><AiShanhaijingAdmin/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/ai_shanhaijing_admin/*" element={<ProtectedRoute><MainLayout><AiShanhaijingAdmin/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/urban_legend_admin" element={<ProtectedRoute><MainLayout><UrbanLegendAdmin/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/star_card_admin" element={<ProtectedRoute><MainLayout><StarCardAdmin/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/entity_file_admin" element={<ProtectedRoute><MainLayout><EntityFileAdmin/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/synthetic_admin" element={<ProtectedRoute><MainLayout><SyntheticAdmin/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/deep_monsters_admin" element={<ProtectedRoute><MainLayout><DeepMonstersAdmin/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/card_maker_admin" element={<ProtectedRoute><MainLayout><CardMakerAdmin/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/gjp" element={<ProtectedRoute><MainLayout><Gjp/></MainLayout></ProtectedRoute>} />
          <Route path="/tools/gjp_order" element={<ProtectedRoute><MainLayout><GjpOrder/></MainLayout></ProtectedRoute>} />
          <Route path="/login" element={<EmptyLayout><Login/></EmptyLayout>} />
          <Route path="" element={<ProtectedRoute><MainLayout><JDProductsPrint/></MainLayout></ProtectedRoute>} />
        </Routes>
      </Router>
    );
  }
}

export default App;